import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { HashMap } from '@jsverse/transloco';

@Component({
  selector: 'rpl-confirmation-dialog',
  standalone: true,
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  protected readonly dialogRef =
    inject<
      MatDialogRef<ConfirmationDialogComponent, IConfirmationDialogResult>
    >(MatDialogRef);
  protected readonly data = inject<IConfirmationDialogData>(MAT_DIALOG_DATA);

  constructor() {
    this.dialogRef.disableClose = this.data.disableBackdropClick;
  }

  protected onAccept(): void {
    this.dialogRef.close({ accepted: true });
  }
}

export interface IConfirmationDialogData {
  header: string;
  message: string;
  messageInterpolateParams?: HashMap;
  acceptLabel: string;
  rejectLabel: string;
  disableBackdropClick: boolean;
}

export interface IConfirmationDialogResult {
  accepted: boolean;
}
